import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-355fa945"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content postcodesearch-modal" }
const _hoisted_4 = { class: "modal-header postcode-modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "postcode-report-saarch-modal-label",
  style: {"width":"100%"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 mt-auto mb-auto" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mt-auto mb-auto" }, "Creating a new booking")
], -1))
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "card bg-light postcode-search-booking-section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-header postcode-search-section-header" }, " First Choice - There is an existing booking for this property within the new diary system ", -1))
const _hoisted_15 = { class: "card-body postcode-property-container" }
const _hoisted_16 = { class: "table table-hover" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Date"),
  /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Time"),
  /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Job Type"),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Address"),
  /*#__PURE__*/_createElementVNode("th", { width: "12%" }, "Customer"),
  /*#__PURE__*/_createElementVNode("th", { width: "12%" }, "Branch"),
  /*#__PURE__*/_createElementVNode("th", { width: "12%" }, "Inspector"),
  /*#__PURE__*/_createElementVNode("th", { width: "9%" })
], -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-google" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = { class: "card bg-light postcode-search-section mt-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-header postcode-search-section-header" }, " Second Choice - No booking has been compiled within the new diary system but historic report available on CMS ", -1))
const _hoisted_32 = { class: "card-body postcode-property-container" }
const _hoisted_33 = { class: "table table-hover" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Date"),
  /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Ref"),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Type"),
  /*#__PURE__*/_createElementVNode("th", { width: "40%" }, "Address"),
  /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Select")
], -1))
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "card bg-light postcode-search-section mt-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-header postcode-search-section-header" }, " New to ACT - No booking or report on our new system - General Postcode Search ", -1))
const _hoisted_42 = { class: "card-body postcode-property-container" }
const _hoisted_43 = { class: "table table-hover" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "80%" }, "Address"),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Select")
], -1))
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_49 = [
  _hoisted_48
]

import $ from 'jquery';
import moment from "moment-timezone";
import { computed, inject, ref, nextTick, PropType } from 'vue';
import { useStore } from 'vuex';
import { Report, Dictionary, PropertySpec, Booking } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostcodeReportSearchModal',
  props: {
  title: {type: String as PropType<string>, default: '', required: false},
  refname: {type: String as PropType<string>, default: '', required: false},
},
  emits: ['previousbookingselected', 'showmatchingproperywarning','googlebookingselected'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const store = useStore();
const actProperty: any = inject('actProperty');
const realtime: any = inject('realtime');

const filterreport = ref(new Report);
const addressfilter = ref('');
const addressfilterref = ref(null);
const reports = computed(() => store.getters['reports/list']);
const postcodesearchreports = computed(() => store.getters['reports/postcodesearchlist']);
const postcodesearchbookings = computed(() => store.getters['diary/postcodesearchlist']);
const dictionary = computed(() => store.getters['dictionary/current']);
const propertyspec = computed(() => store.getters['diary/propertyspec']);
const emit = __emit;
const booking = computed(() => store.getters['diary/booking']);

const setReports = (reports: Report[]): void => {
  store.commit('reports/setReports', reports);
};

const setPostcodeReports = (reports: Report[]): void => {
  store.commit('reports/setPostcodeReports', reports);
};

const setPostcodeBookings = (bookings: Booking[]): void => {
  store.commit('diary/setPostcodeBookings', bookings);
};

const setPreviousreport = (previousreport: Report): void => {
  store.commit('diary/setPreviousreport', previousreport);
};

const setDataentryreport = (dataentryreport: Report): void => {
  store.commit('diary/setDataentryreport', dataentryreport);
};

const setPreviousbooking = (booking: Booking): void => {
  store.commit('diary/setPreviousbooking', booking);
};

const setBookingDeep = (payload: { path: string; data: any }): void => {
  store.commit('diary/setBookingDeep', payload);
};

const setAddressDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('diary/setAddressDeep', payload);
};
const internaljobtypedisplayname = computed((): Map<string, string> => store.getters['diary/internaljobtypedisplayname']);
const setPropertyspecDeep = (payload: {
  path: string;
  data: any;
}): Promise<any> => {
  return store.dispatch('diary/setPropertyspecDeep', payload);
};

const getReport = (id: string): Promise<Report> => {
  return store.dispatch('reports/getReport', id);
};

const getBooking = (payload: { id: string; cancelled: string }): Promise<Booking> => {
  return store.dispatch('diary/getBookingWithoutStoringInState', payload);
};

const init = () => {
  filterreport.value = new Report;
  addressfilter.value = '';
  setReports([]);
  setPostcodeReports([]);
  setPostcodeBookings([]);

  nextTick(() => {
    (addressfilterref.value as any).focus();
  })
}

const selectreport = async (report: Report) => {
  if (report.id) {
    const fetchedReport = await getReport(report.id);
    if (fetchedReport) {
      setDataentryreport(new Report());
      setBookingDeep({ path: "dataentrydocuments", data: [] });
      setPreviousreport(fetchedReport);
      setBookingFieldsFromReport(fetchedReport);
      hide();
    }
  } else {
    setPreviousreport(new Report());
    setBookingFieldsFromReport(report);
    hide();
    const foundmatchingproperties = checkPropertyOnSystem(report);
    if(foundmatchingproperties) {
      emit('showmatchingproperywarning')
    }
  }
};

const checkPropertyOnSystem = (report: Report) => {
  const foundreports = filteredreports.value.filter((dbreport: Report) => dbreport.address.isMatching(report.address));
  const foundbookings = filteredbookings.value.filter((dbbooking: Booking) => dbbooking.address.isMatching(report.address));
  return foundreports.length > 0 || foundbookings.length > 0;
}

const selectbooking = async (booking: Booking) => {
  if (booking.id) {
    const fetchedBooking = await getBooking({ id: booking.id, cancelled: '' });
    if (fetchedBooking) {
      setPreviousbooking(fetchedBooking);
      emit('previousbookingselected', fetchedBooking);
      hide();
    }
  } else {
    setPreviousbooking(new Booking());
    hide();
  }
};

const setBookingFieldsFromReport = (report: Report) => {
  if (report) {
    setAddressDeep({ path: "line1", data: report.address.line1 });
    setAddressDeep({ path: "line2", data: report.address.line2 });
    setAddressDeep({ path: "town", data: report.address.town });
    setAddressDeep({ path: "county", data: report.address.county });

    setPropertyspecDeep({
      path: "bedrooms",
      data: findRoomtypeCount(report, ["bedroom"]),
    });
    setPropertyspecDeep({
      path: "bathrooms",
      data: findRoomtypeCount(report, ["bathroom", "ensuite"]),
    });
    setPropertyspecDeep({
      path: "receptions",
      data: findRoomtypeCount(report, ["reception"]),
    });
    setPropertyspecDeep({
      path: "furnished",
      data: report.propertyDetails.furnished,
    });

    let totalrooms = 0;
    if (propertyspec.value) {
      if (propertyspec.value.bedrooms)
        totalrooms += propertyspec.value.bedrooms;
      if (propertyspec.value.bathrooms)
        totalrooms += propertyspec.value.bathrooms;
      if (propertyspec.value.receptions)
        totalrooms += propertyspec.value.receptions;
    }
  }
};

const findRoomtypeCount = (report: Report, roomtypes: string[]): number => {
  let count = 0;
  if (report && report.rooms && report.rooms.length) {
    count = report.rooms.filter((r) => {
      let index = roomtypes.findIndex((type: string) => type === r.type);
      return index >= 0;
    }).length;
  }
  return count;
};

const filteredpostcodesearchreports = computed(() => {
  if (addressfilter.value) {
    const lowercaseaddressfilter = addressfilter.value.toLowerCase();
    return postcodesearchreports.value.filter((r: Report) => {
      if (r.address.line1.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (r.address.line2.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (r.address.town.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (r.address.county.toLowerCase().includes(lowercaseaddressfilter)) return true;
      return false;
    });
  } else {
    return postcodesearchreports.value;
  }
});

const filteredreports = computed(() => {
  let frlist: Report[] = sortedreportlist.value.filter((r: Report) => {
      if (booking.value?.id && booking.value?.targetreport?.id && booking.value?.targetreport?.ref && booking.value.targetreport.ref === r.ref) return false;
      return true;
    });
  let filteredlist: Report[] = [];
  if (addressfilter.value) {
    const lowercaseaddressfilter = addressfilter.value.toLowerCase();
    filteredlist = frlist.filter((r: Report) => {
      if (r.address.line1.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (r.address.line2.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (r.address.town.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (r.address.county.toLowerCase().includes(lowercaseaddressfilter)) return true;
      return false;
    });
  } else {
    filteredlist = frlist;
  }
  return filteredlist.filter((r: Report) => !r.address?.line1?.includes('PROFORMA'));
});

const filteredbookings = computed(() => {
  const fblist = sortedpostcodesearchbookings.value.filter((b: Booking) => {
      if (booking.value?.id && b.id === booking.value?.id) return false;
      return true;
    });
  if (addressfilter.value) {
    const lowercaseaddressfilter = addressfilter.value.toLowerCase();
    return fblist.filter((b: Booking) => {
      if (b.address.line1.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (b.address.line2.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (b.address.town.toLowerCase().includes(lowercaseaddressfilter)) return true;
      if (b.address.county.toLowerCase().includes(lowercaseaddressfilter)) return true;
      return false;
    });
  } else {
    return fblist;
  }
});

const sortedreportlist = computed(() => {
  let sortedlist = [...reports.value];
  if (
    filterreport.value &&
    filterreport.value.address &&
    filterreport.value.address.line1
  ) {
    sortedlist = sortedlist.sort((a: Report, b: Report) => {
      let aline1 = a.address?.line1 ?? '';
      aline1 = aline1.replaceAll("PROFORMA INVOICE ", "")
                     .replaceAll("INVOICE ONLY ", "")
                     .replaceAll("UPLOAD ", "");

      let bline1 = b.address?.line1 ?? '';
      bline1 = bline1.replaceAll("PROFORMA INVOICE ", "")
                     .replaceAll("INVOICE ONLY ", "")
                     .replaceAll("UPLOAD ", "");
      
      if (moment.utc(a.date).isAfter(moment.utc(b.date))) {
        return 1;
      } else if (
        moment.utc(a.date).isBefore(moment.utc(b.date))
      ) {
        return -1;
      } else {
        if (aline1 && aline1.startsWith(filterreport.value.address.line1)) return -1;
        if (bline1 && bline1.startsWith(filterreport.value.address.line1)) return 1;
        return 0;
      }
    });
  }
  return sortedlist;
});

const sortedpostcodesearchbookings = computed(() => {
  let sortedlist = [...postcodesearchbookings.value];
  if (
    filterreport.value &&
    filterreport.value.address &&
    filterreport.value.address.line1
  ) {
    sortedlist = sortedlist.sort((a: Booking, b: Booking) => {
      let aline1 = a.address?.line1 ?? '';
      aline1 = aline1.replaceAll("PROFORMA INVOICE ", "")
                     .replaceAll("INVOICE ONLY ", "")
                     .replaceAll("UPLOAD ", "");

      let bline1 = b.address?.line1 ?? '';
      bline1 = bline1.replaceAll("PROFORMA INVOICE ", "")
                     .replaceAll("INVOICE ONLY ", "")
                     .replaceAll("UPLOAD ", "");

      if (moment.utc(a.startDate).isAfter(moment.utc(b.startDate))) {
        return 1;
      } else if (
        moment.utc(a.startDate).isBefore(moment.utc(b.startDate))
      ) {
        return -1;
      } else {
        if (aline1 && aline1.startsWith(filterreport.value.address.line1)) return -1;
        if (bline1 && bline1.startsWith(filterreport.value.address.line1)) return 1;
        return 0;
      }
    });
  }
  return sortedlist;
});

const highlight = computed(() => {
  let val = '';
  const firsttablecount = filteredbookings.value.filter((b: Booking) => !b.googleid).length;
  const secondtablecount = filteredreports.value.length;
  if(firsttablecount > 0) {
    val = 'first';
  }
  else if(secondtablecount > 0) {
    val = 'second';
  }
  else {
    val = 'third';
  }
  return val;
})

const show = () => {
  if ($(`#${props.refname}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.refname + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    let modalEl = $(`#${props.refname}`);
    modalEl.show();
  }
}
const hide = () => {
  if ($(`#${props.refname}`).length > 0) {
    $(`#${props.refname}` + 'Backdrop').remove();
    $(`#${props.refname}`).hide();
  }
};
const customLabelForInternaljobtype = (internaljobtype: string): string => {
  return actProperty.customLabelForInternaljobtype(internaljobtypedisplayname.value,internaljobtype )
}
__expose({init, show, hide});

const googleeventpopup = (b:Booking) =>{
    if (b.googleid) {
      emit('googlebookingselected', b);
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.refname,
    class: "modal",
    "data-backdrop": "false",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`postcode-search-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  ref_key: "addressfilterref",
                  ref: addressfilterref,
                  class: "form-control height-43",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressfilter).value = $event)),
                  autocomplete: "addressfilter"
                }, null, 512), [
                  [_vModelText, addressfilter.value]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: hide
          }, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["row", {'greyed': highlight.value != 'first'}])
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("table", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredbookings.value, (b) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: b.id,
                          class: _normalizeClass({'cancelled-booking': b.cancelled}),
                          onClick: ($event: any) => (googleeventpopup(b))
                        }, [
                          _createElementVNode("td", null, _toDisplayString(b.bookingdate), 1),
                          _createElementVNode("td", null, _toDisplayString(b.starttime) + " to " + _toDisplayString(b.endtime), 1),
                          _createElementVNode("td", null, [
                            (!b.googleid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  (b.subtype)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(b.subtype), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(customLabelForInternaljobtype(b.internaljobtype)), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                          ]),
                          _createElementVNode("td", null, [
                            (!b.googleid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(b.addressPreview), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                  _createElementVNode("div", null, _toDisplayString(b.location), 1),
                                  _createElementVNode("div", null, _toDisplayString(b.summary), 1)
                                ]))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(b.customer.companyName), 1),
                          _createElementVNode("td", null, _toDisplayString(b.customer.branchName), 1),
                          _createElementVNode("td", null, _toDisplayString(b.inspector.name), 1),
                          _createElementVNode("td", null, [
                            (!b.cancelled && b.isMasterBooking())
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-light ml-1",
                                  title: "Select",
                                  onClick: _withModifiers(($event: any) => (selectbooking(b)), ["stop"])
                                }, _hoisted_28, 8, _hoisted_26))
                              : _createCommentVNode("", true)
                          ])
                        ], 10, _hoisted_18))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["row", {'greyed': highlight.value != 'second'}])
          }, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("table", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredreports.value, (report) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: report.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatDateForDisplay(report.date)), 1),
                          _createElementVNode("td", null, _toDisplayString(report.ref), 1),
                          _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatReportType(
                              report.type,
                              dictionary.value
                            )), 1),
                          _createElementVNode("td", {
                            innerHTML: 
                            _unref(actProperty).formatAddress(report.address, ', ')
                          
                          }, null, 8, _hoisted_35),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-light ml-1",
                              title: "Select",
                              onClick: ($event: any) => (selectreport(report))
                            }, _hoisted_38, 8, _hoisted_36)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["row", {'greyed': highlight.value != 'third'}])
          }, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("table", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredpostcodesearchreports.value, (report) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: report.id,
                          onClick: ($event: any) => (filterreport.value = report),
                          class: _normalizeClass({
                          selected:
                            report.address.line1 === filterreport.value.address.line1,
                        })
                        }, [
                          _createElementVNode("td", {
                            innerHTML: 
                            _unref(actProperty).formatAddress(report.address, ', ')
                          
                          }, null, 8, _hoisted_46),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-light ml-1",
                              title: "Select",
                              onClick: ($event: any) => (selectreport(report))
                            }, _hoisted_49, 8, _hoisted_47)
                          ])
                        ], 10, _hoisted_45))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ], 2)
        ]),
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            "data-dismiss": "modal",
            onClick: hide
          }, " Close ")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})